import classNames from "classnames/bind";
import { NavBar } from "common/components/NavBar";
import { useSidebarContext } from "common/context/SidebarContext";
import React from "react";
import styles from "./DefaultLayout.module.css";

const classNameBuilder = classNames.bind(styles);

type Props = {
  showNavBar?: boolean;
};

export const DefaultLayout: React.FC<React.PropsWithChildren<Props>> = ({
  showNavBar = true,
  children,
}) => {
  const { open, setOpen } = useSidebarContext();

  const classes = classNameBuilder({
    grid: true,
    gridOpenSidebar: open,
    gridClosedSidebar: !open,
  });

  return (
    <>
      {showNavBar && (
        <header className={styles.header}>
          <NavBar isMenuOpen={open} handleOnMenuClick={setOpen} />
        </header>
      )}
      <main className={showNavBar ? classes : undefined}>
        <div className={styles.content}>{children}</div>
      </main>
    </>
  );
};
